export default "__VITE_ASSET__Iu5Lfu_c__"